import React from 'react';
import PropTypes from 'prop-types';
import DroppableDiv from 'components/Common/DroppableDiv';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FileUploadIcon from 'icons/FileUpload';
import Styles from './index.module.css';

export default function FormFileDrop({
  onSelectFile,
  title,
  description,
  selectedFilename,
  accept,
}) {
  return (
    <DroppableDiv
      onClick={selectedFilename ? () => onSelectFile([]) : null}
      accept={accept}
      onDrop={onSelectFile}
      className={Styles.mainContainer}
    >
      {!selectedFilename && (
        <>
          <div className={Styles.arrowContainer}>
            <FileUploadIcon style={{ fontSize: 60, fill: '#BFCFEF' }} />
          </div>
          {(title || description) && (
            <div className={Styles.textContainer}>
              <FormLabel title={title} description={description} />
            </div>
          )}
        </>
      )}
      {selectedFilename && (
        <div className={Styles.filenameContainer}>{selectedFilename}</div>
      )}
    </DroppableDiv>
  );
}

FormFileDrop.propTypes = {
  accept: PropTypes.string,
  onSelectFile: PropTypes.func,
  selectedFilename: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

FormFileDrop.defaultProps = {
  accept: '',
  onSelectFile: () => {},
  selectedFilename: '',
  title: '',
  description: '',
};
